import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

export default function BroadcastPanel() {
  const [content, setContent] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    if (!content.trim()) return;
    if (!window.confirm("Send this message to ALL members? It will land in every member's inbox.")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/broadcast", { content });
      toast.success(`Message sent to ${data.sent} member${data.sent === 1 ? "" : "s"}`);
      setContent("");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="broadcast-panel">
      <p className="text-sm text-zinc-500 mb-3">Message every member at once — it lands in each member's inbox with a notification. Member replies show up in your Messages on the Community page.</p>
      <textarea data-testid="broadcast-input" value={content} onChange={(e) => setContent(e.target.value)} rows={3}
        placeholder="e.g. Courts open late this Friday — extra drill sessions added at 7pm!"
        className="w-full bg-pb-elevated border border-pb-border p-3 text-white placeholder-zinc-600 focus:outline-none focus:border-pb-red resize-none text-sm" />
      <button data-testid="broadcast-send-btn" onClick={send} disabled={busy || !content.trim()}
        className="mt-2 flex items-center gap-2 bg-pb-red text-black font-bold uppercase tracking-widest text-xs px-5 py-2.5 hover:bg-[#BEF264] active:scale-95 transition-all disabled:opacity-40">
        <Send className="w-4 h-4" /> {busy ? "Sending…" : "Send to All Members"}
      </button>
    </div>
  );
}
